export default "__VITE_ASSET__Bd7afieT__"